import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetStreetScapeTrackerTableRequest,
	CreateStreetScapeEntryRequest,
	EditStreetScapeEntryRequest,
	GetCommentsHistoryRequest,
	GetStreetScapeTrackerRequest,
	GetStreetScapeTrackerToEditRequest,
	GetExportTrackerRequest,
	RemoveStreetScapeEntryRequest,
	GetReportEmailRequest,
	GetStreetScapeLocalDropdownRequest,
	GetStreetScapeClusterDropdownRequest,
	GetStreetScapeSiteNameDropdownRequest,
	GetActivationStatusDropdownRequest,
	GetD7StatusDropdownRequest
} from '../requests/StreetScapeTrackerRequests';

export const GET_STREETSCAPE_TRACKER_TABLE = 'GET_STREETSCAPE_TRACKER_TABLE';
export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_STREETSCAPE_TRACKER = 'GET_STREETSCAPE_TRACKER';
export const GET_COMMENTS_HISTORY = 'GET_COMMENTS_HISTORY';
export const GET_STREETSCAPE_TRACKER_TO_EDIT = 'GET_STREETSCAPE_TRACKER_TO_EDIT';
export const TOGGLE_STREETSCAPE_TRACKER_DIALOG = 'TOGGLE_STREETSCAPE_TRACKER_DIALOG';
export const GET_LOCAL_DROPDOWN = 'GET_LOCAL_DROPDOWN';
export const GET_CLUSTER_DROPDOWN = 'GET_CLUSTER_DROPDOWN';
export const GET_SITENAME_DROPDOWN = 'GET_SITENAME_DROPDOWN';
export const GET_ACTIVATION_STATUS_DROPDOWN = 'GET_ACTIVATION_STATUS_DROPDOWN';
export const GET_D7_STATUS_DROPDOWN = 'GET_D7_STATUS_DROPDOWN';

const onGetStreetScapeTrackerTable = (value) => ({
	type: GET_STREETSCAPE_TRACKER_TABLE,
	streetScapeTrackerTable: value
});

export const GetStreetScapeTrackerTable = () => async (dispatch) => {
	await GetStreetScapeTrackerTableRequest().then(response => {
		dispatch(onGetStreetScapeTrackerTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onToggleStreetScapeTrackerDialog = (visible, streetScapeTrackerId) => ({
	type: TOGGLE_STREETSCAPE_TRACKER_DIALOG,
	visible,
	streetScapeTrackerId
});

export const ToggleStreetScapeTrackerDialog = (visible, streetScapeTrackerId) => (dispatch) => {
	dispatch(onToggleStreetScapeTrackerDialog(visible, streetScapeTrackerId));
};

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const CreateStreetScapeEntry = (streetScapeTrackerCreateDto) => async (dispatch) => {
	await CreateStreetScapeEntryRequest(streetScapeTrackerCreateDto).then(response => {
		dispatch(enqueueSnackbar({ message: 'Entry successfully created.', options: { variant: 'success' } }));
		dispatch(GetStreetScapeTrackerTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditStreetScapeEntry = (streetScapeTrackerForm) => async (dispatch) => {
	await EditStreetScapeEntryRequest(streetScapeTrackerForm).then(response => {
		dispatch(enqueueSnackbar({ message: 'Entry successfully edited.', options: { variant: 'success' } }));
		dispatch(GetStreetScapeTrackerTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetCommentsHistory = (value, valueType) => ({
	type: GET_COMMENTS_HISTORY,
	commentsHistory: value,
	commentType: valueType
});

export const GetCommentsHistory = (id, commentType) => async (dispatch) => {
	await GetCommentsHistoryRequest(id, commentType).then(response => {
		dispatch(onGetCommentsHistory(response.data, commentType));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetStreetScapeTracker = (value) => ({
	type: GET_STREETSCAPE_TRACKER,
	streetScapeTracker: value
});

export const GetStreetScapeTracker = (id) => async (dispatch) => {
	await GetStreetScapeTrackerRequest(id).then(response => {
		dispatch(onGetStreetScapeTracker(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetStreetScapeTrackerToEdit = (value) => ({
	type: GET_STREETSCAPE_TRACKER_TO_EDIT,
	streetScapeTracker: value
});

export const GetStreetScapeTrackerToEdit = (id) => async (dispatch) => {
	await GetStreetScapeTrackerToEditRequest(id).then(response => {
		dispatch(onGetStreetScapeTrackerToEdit(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetExportTracker = () => async (dispatch) => {
	await GetExportTrackerRequest().then(response => {
		dispatch(DownloadFile(response.data));
		dispatch(enqueueSnackbar({ message: 'Tracker successfully exported.', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RemoveStreetScapeEntry = (id, user) => async (dispatch) => {
	await RemoveStreetScapeEntryRequest(id, user).then(response => {
		dispatch(enqueueSnackbar({ message: 'Entry successfully removed.', options: { variant: 'success' } }));
		dispatch(GetStreetScapeTrackerTable());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetReportEmail = (id, user) => async (dispatch) => {
	await GetReportEmailRequest(id, user).then(response => {
		dispatch(DownloadFile(response.data));
		dispatch(enqueueSnackbar({ message: 'Report successfully downloaded.', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetLocalDropdown = (value) => ({
	type: GET_LOCAL_DROPDOWN,
	siteLocalDropdown: value
});

export const GetLocalDropdown = () => async (dispatch) => {
	await GetStreetScapeLocalDropdownRequest().then(response => {
		dispatch(onGetLocalDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetClusterDropdown = (value) => ({
	type: GET_CLUSTER_DROPDOWN,
	siteClusterDropdown: value
});

export const GetClusterDropdown = (local) => async (dispatch) => {
	await GetStreetScapeClusterDropdownRequest(local).then(response => {
		dispatch(onGetClusterDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetSiteNameDropdown = (value) => ({
	type: GET_SITENAME_DROPDOWN,
	siteNameDropdown: value
});

export const GetSiteNameDropdown = (cluster) => async (dispatch) => {
	await GetStreetScapeSiteNameDropdownRequest(cluster).then(response => {
		dispatch(onGetSiteNameDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetActivationStatusDropdown = (value) => ({
	type: GET_ACTIVATION_STATUS_DROPDOWN,
	activationStatusDropdown: value
});

export const GetActivationStatusDropdown = () => async (dispatch) => {
	await GetActivationStatusDropdownRequest().then(response => {
		dispatch(onGetActivationStatusDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onGetD7StatusDropdown = (value) => ({
	type: GET_D7_STATUS_DROPDOWN,
	d7StatusDropdown: value
});

export const GetD7StatusDropdown = () => async (dispatch) => {
	await GetD7StatusDropdownRequest().then(response => {
		dispatch(onGetD7StatusDropdown(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
